import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_MYTHIC_DUNGEON_INVITATIONAL_DATA,
  SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD,
  SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD_FILTER,
  SET_MYTHIC_DUNGEON_INVITATIONAL_SUMMARY,
  SHOW_LOADING_SPINNER
} from '../actions/mythicDungeonInvitationalActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

const leaderboardDefaultFilters = {
  dungeon: 'all',
  affixes: 'all',
  region: 'world'
};

export default function mythicDungeonInvitationalReducer(state: Partial<any> = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_MYTHIC_DUNGEON_INVITATIONAL_DATA: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SET_MYTHIC_DUNGEON_INVITATIONAL_SUMMARY: {
      return {
        ...state,
        tournamentSummary: action.payload
      };
    }
    case SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD: {
      return {
        ...state,
        leaderboard: action.payload,
        leaderboardFilter: {
          ...leaderboardDefaultFilters,
          ...action.payload.ui
        }
      };
    }
    case SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD_FILTER: {
      return {
        ...state,
        leaderboardFilter: {
          ...leaderboardDefaultFilters,
          ...action.payload
        }
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default: {
      return state;
    }
  }
}
